module.exports = __webpack_public_path__ + "static/solid-banner-358d0b4842146930fde7871a48319cc4.png";